import { useEffect, useState } from 'react';

import { fetchAddressSuggestions } from '@bodilenergy/address';
import { DAWAAutocompleteSuggestion } from '~src/model';

const MINIMUM_SEARCH_LENGTH = 2;

export const useAddressLookup = () => {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState<DAWAAutocompleteSuggestion[]>([]);
  const [lookupError, setLookupError] = useState<unknown>();

  useEffect(() => {
    if ((input?.length ?? 0) < MINIMUM_SEARCH_LENGTH) {
      return;
    }

    // Typing aborts the previous search, so a slow answer never replaces a newer one.
    const controller = new AbortController();

    fetchAddressSuggestions(input, { signal: controller.signal })
      .then(data => {
        if (!controller.signal.aborted) {
          setLookupError(undefined);
          setSuggestions(data ?? []);
        }
      })
      .catch(error => {
        if (!controller.signal.aborted) {
          setLookupError(error);
          setSuggestions([]);
        }
      });

    return () => controller.abort();
  }, [input]);

  return {
    suggestions,
    lookupError,
    resetSuggestions: () => setSuggestions([]),
    input,
    setInput,
  };
};
